import type { SVGProps } from "react";
const SvgPatternBackground = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 110 390 260"
    aria-hidden="true"
    {...props}
  >
    <g fillRule="evenodd" clipRule="evenodd" opacity={0.05}>
      <use href="#patternBackground_svg__a" />
      <use y={50} href="#patternBackground_svg__a" />
      <use y={100} href="#patternBackground_svg__a" />
      <use y={150} href="#patternBackground_svg__a" />
    </g>
    <defs>
      <linearGradient
        id="patternBackground_svg__b"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#047E4B" />
        <stop offset={0.52} stopColor="#00B66E" />
        <stop offset={1} stopColor="#969696" />
      </linearGradient>
      <path
        id="patternBackground_svg__a"
        fill="url(#patternBackground_svg__b)"
        d="M393.37 115.03c41.34-10.54 83.56-20.08 125.6-22.43l1.13 22.8c-39.88 2.23-80.41 11.32-121.58 21.81-8.82 2.25-17.69 4.57-26.58 6.9-32.28 8.44-64.91 16.97-97.05 22.61-47.5 8.34-105.14 16.4-160 11.75-54.87-4.64-108.45-22.1-146.15-66.24L-14.92 97c32.47 38.03 79.61 54.3 131.61 58.7s107.38-3.21 154.61-11.5l1.8 11.26-1.8-11.26c31.2-5.48 62.72-13.72 94.87-22.13 9.01-2.35 18.08-4.72 27.2-7.05Z"
      />
    </defs>
  </svg>
);
export default SvgPatternBackground;
